module.exports = __webpack_public_path__ + "img/sideGreen.96e01215.png";